import React from 'react';

import { set, clear } from '../map';

export class ScrollElement extends React.Component<ScrollElementProps> {
  static defaultProps = {
    children: null,
  };

  node: HTMLElement | null = null;

  componentDidMount() {
    set(this.props.name, this.node);
  }

  componentWillUnmount() {
    clear(this.props.name);
  }

  render() {
    return (
      <section
        ref={node => {
          this.node = node;
        }}
        data-test={this.props['data-test']}
        className={this.props.className}
      >
        {this.props.children}
      </section>
    );
  }
}

interface ScrollElementProps {
  name: string;
  children: React.ReactNode;
  'data-test'?: string;
  className?: string;
}
